<template>
    <label class="radio-wrapper">
        <input type="radio"
               :value="inputValue"
               :name="name"
               v-model="model" />

        <IconRadioOff class="icon-off" />

        <IconRadioOn class="icon-on" />

        <span class="radio-label">{{ label }}</span>
    </label>
</template>

<script>
import IconRadioOff from './icons/IconRadioOff.vue';
import IconRadioOn from './icons/IconRadioOn.vue';

export default {
    name: 'RadioButton',
    components: {
        IconRadioOff,
        IconRadioOn,
    },
    props: {
        inputValue: { type: null, required: false },
        value: { type: null },
        label: { type: String, required: true },
        name: { type: [String, Number] }
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.radio-wrapper {
    position: relative;
    display: flex;
    align-items: center;

    width: fit-content;

    cursor: pointer;
    line-height: 20px;

    input[type="radio"] {
        display: none;
    }

    .icon-on,
    .icon-off {
        position: absolute;
        left: 0;

        width: 20px;
        height: 20px;

        vertical-align: middle;
        transition: opacity 0.3s ease;
    }

    /* Unselected radio outline follows the venue brand colour (currentColor
       drives the icon stroke) instead of the off-brand electric blue. */
    .icon-off {
        color: var(--color-primary);
    }

    .icon-on,
    input[type="radio"]:checked+.icon-off {
        opacity: 0;
    }

    .icon-off,
    input[type="radio"]:checked+.icon-off+.icon-on {
        opacity: 1;
    }

    .radio-label {
        padding-left: 32px;

        font-weight: 400;
        font-size: 14px;

        color: var(--text-primary);
    }
}
</style>